import { render, staticRenderFns } from "./MyLoader.vue?vue&type=template&id=5f18145d"
import script from "./MyLoader.vue?vue&type=script&lang=js"
export * from "./MyLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports